import { useMutation, MutationHookOptions } from '@apollo/client';
import { gql } from '__generated__/gql';
import { SetSessionTeamMutation, SetSessionTeamMutationVariables } from '__generated__/graphql';
import { useAuth } from 'components/providers/AuthProvider';
import { useDefaultOnError } from 'hooks/useDefaultOnError';

const SET_SESSION_TEAM_MUTATION = gql(/* GraphQL */ `
  mutation setSessionTeam($input: SetSessionTeamInput!) {
    setSessionTeam(input: $input) {
      clientMutationId
    }
  }
`);

export function useSetSessionTeam(
  options?: MutationHookOptions<SetSessionTeamMutation, SetSessionTeamMutationVariables>,
) {
  const { fetchSessionData } = useAuth();
  const onError = useDefaultOnError();

  return useMutation(SET_SESSION_TEAM_MUTATION, {
    onCompleted: async () => {
      await fetchSessionData();
      window.location.href = '/';
    },
    onError: (err) => onError(err),
    ...options,
  });
}
